// DO NOT EDIT THIS IS AN AUTOGENERATED FILE;
import * as React from 'react'

interface IconProps {
  color?: string
  size?: string | number
}

const SvgSatellite = ({color = 'currentColor', size = 20}: IconProps) => (
  <svg
    viewBox="0 0 20 20"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    height={size}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.871 2.23a.75.75 0 0 1 1.06 0l3.89 3.889 1.9-1.9a.75.75 0 1 1 1.06 1.061l-1.9 1.9 3.89 3.889a.75.75 0 0 1 0 1.06c-2.578 2.578-6.455 2.543-9.16.329l-3.454 3.62a.25.25 0 0 0 .18.422h4.664a.75.75 0 0 1 0 1.5H5.337c-1.54 0-2.328-1.845-1.265-2.958l3.478-3.644C5.328 8.693 5.29 4.81 7.87 2.23Zm.567 1.628c-1.59 2.107-1.318 5.04.673 7.031 1.992 1.992 4.924 2.263 7.032.674L8.438 3.857Z"
    />
  </svg>
)

export default SvgSatellite
